import { render, staticRenderFns } from "./NoticeCodAgreement.vue?vue&type=template&id=1078dbcd&scoped=true&"
import script from "./NoticeCodAgreement.vue?vue&type=script&lang=js&"
export * from "./NoticeCodAgreement.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCodAgreement.vue?vue&type=style&index=0&id=1078dbcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078dbcd",
  null
  
)

export default component.exports